import LogInCodeSabad from "components/sabad-kharid/LogInCodeSabad";
import LogInNumber from "components/sabad-kharid/LogInNumber";
import MyAddress from "components/sabad-kharid/MyAddress";
import MyPay from "components/sabad-kharid/MyPay";
import { connection } from "utils/apiConnection.ts";
import React, { useState, useEffect, useContext } from "react";
import { FaCheck } from "react-icons/fa";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { Modal } from "react-bootstrap";
import { MdOutlineShoppingCart } from "react-icons/md";
import Loader from "utils/Loader";
import CartItemsContext from "context/ShoppingCartItems";

function SabadKharid() {
  const {
    shoppingData,
    updateShoppingList,
    shoppingDataBusiness,
    currentInventory,
    prices,
    setPrices,
    itemsCount,
    itemsId,
    supplierCount,
  } = useContext(CartItemsContext);
  const auth = useContext(WithAuthentication);
  const [modalStar, setmodalStar] = useState(0);
  const [loginkeyStar, setloginkeyStar] = useState("");
  const [numberStar, setnumberStar] = useState("");
  const [item, setItems] = useState(0);
  const [addressId, setAddressId] = useState("-1");
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleAddress = (id) => {
    setAddressId(id);
  };

  let SetNumberStar = (e) => {
    setnumberStar(e.target.value);
  };
  function changemodalStar(modalNumber) {
    setmodalStar(modalNumber);
  }
  function LoginKeyStar(loginKey) {
    setloginkeyStar(loginKey);
  }
  function BackStar() {
    setmodalStar(0);
  }
  useEffect(() => {
    updateShoppingList();
  }, [show]);

  // shopping basket
  // const [shoppingData, setShoppingData] = useState([]);
  // const [updater, setUpdater] = useState(false);
  // const [prices, setPrices] = useState({
  //   total: "",
  //   product: "",
  //   basket: "",
  //   discount: "",
  //   send: "",
  // });
  // const [currentInventory, setCurrentInventory] = useState("");
  // const updateShoppingList = () => {
  //   setUpdater((prev) => !prev);
  // };
  // useEffect(() => {
  //   if (show === true) {
  //     setIsLoading(true);
  //     connection("api/getcartitems").then((data) => {
  //       setShoppingData(data.data);
  //       let product = 0,
  //         basket = 0,
  //         total = 0,
  //         discount = 0;
  //       for (let i = 0; i < data.data.length; i++) {
  //         discount += parseInt(
  //           data.data[i].discount * data.data[i].current_count
  //         );
  //         total += parseInt(
  //           (data.data[i].total_price - data.data[i].discount) *
  //             data.data[i].current_count
  //         );
  //         if (data.data[i].rto_basket_id != "0") {
  //           basket += parseInt(
  //             (data.data[i].total_price - data.data[i].discount) *
  //               data.data[i].current_count
  //           );
  //         } else if (data.data[i].rto_basket_id == "0") {
  //           product += parseInt(
  //             (data.data[i].total_price - data.data[i].discount) *
  //               data.data[i].current_count
  //           );
  //         }
  //       }
  //       setPrices((prev) => {
  //         return {
  //           ...prev,
  //           total: total,
  //           discount: discount,
  //           basket: basket,
  //           product: product,
  //         };
  //       });
  //       setIsLoading(false);
  //     });

  //     connection("api/Find_wallets", {
  //       conditions: `uid/=/${auth.userInfo.id}@@type/=/0`,
  //     }).then((data) => {
  //       setCurrentInventory(data[0].current_inventory);
  //       console.log("data[0].current_inventory", data[0].current_inventory);
  //     });
  //   }
  // }, [show, updater]);
  // console.log("isLoading", isLoading);
  // console.log("currentInventory", currentInventory);
  return (
    <>
      <button
        style={{ border: "none", background: "none" }}
        className="position-relative"
        type="button"
        onClick={() => {
          setShow(!show);
          updateShoppingList();
        }}
      >
        <MdOutlineShoppingCart style={{ fontSize: "24px" }} />
        <p
          className="position-absolute bg-danger text-light  rounded-pill"
          style={{
            // padding: "1px 4px",
            fontSize: "14px",
            right: "-3px",
            top: "-5px",
            width: 19,
            height: 19,
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          {itemsCount}
        </p>
      </button>
      <div className="text-center mx-auto">
        <Modal
          // fullscreen={"lg-down"}
          // size={"xl"}
          show={show}
          onHide={() => setShow(false)}
          className="modal-padding modal-shopping"
          // style={{ width: "100%", margin: "20px" }}
        >
          {isLoading && <Loader />}
          <Modal.Header
            className="d-flex flex-row justify-content-between"
            closeButton
          >
            {modalStar == 0 ? (
              <h5 class="modal-title" id="exampleModalLabel">
                سبد خرید
              </h5>
            ) : (
              <button
                type="button"
                className="btn border"
                style={{ boxShadow: "none" }}
                onClick={BackStar}
              >
                بازگشت
              </button>
            )}
          </Modal.Header>
          <Modal.Body
            // className="modal-xl"
            style={{ backgroundColor: "rgb(241, 234, 229)" }}
          >
            <div class=" Orders">
              <div className="text-center">
                <div>
                  <div className=" d-flex justify-content-center align-items-center mt-1">
                    <div
                      className="progresses mx-auto"
                      style={{ width: "90%" }}
                    >
                      <div
                        className={`steps position-relative   ${
                          modalStar == 0
                            ? "process"
                            : modalStar > 0
                            ? "pass"
                            : ""
                        }`}
                      >
                        {/* <span
                        className="position-absolute font-class"
                        style={{ top: "-25px", width: "80px" }}
                      >
                        سبد خرید
                      </span>{" "} */}
                        <span
                          className="font-weight-bold  mx-auto "
                          style={{ marginRight: "-12px" }}
                        >
                          {modalStar == 0 ? (
                            <p
                              className=" font-weight-bold "
                              style={{
                                // fontSize: "24px",
                                marginTop: "auto",
                                // color: "rgb(74, 119, 74)",
                                color: "white",
                              }}
                            >
                              سبدخرید
                              {/* 1 */}
                            </p>
                          ) : modalStar > 0 ? (
                            <>
                              سبدخرید
                              <FaCheck
                                className=""
                                // style={{ color: "rgb(194, 221, 194) " }}
                                style={{ color: "rgb(246 102 86)" }}
                              />
                            </>
                          ) : (
                            // 1
                            "سبد خرید"
                          )}
                        </span>
                      </div>{" "}
                      {/* <span className="line"></span> */}
                      <div
                        className={`steps position-relative  ${
                          modalStar == 1
                            ? "process"
                            : modalStar > 1
                            ? "pass"
                            : ""
                        }`}
                      >
                        {/* {" "}
                      <span
                        className="position-absolute font-class"
                        style={{ top: "-25px", width: "100px" }}
                      >
                        لاگین
                      </span>{" "} */}
                        <span
                          className="font-weight-bold  mx-auto"
                          style={{ marginRight: "-12px" }}
                        >
                          {modalStar == 1 ? (
                            <p
                              className=" font-weight-bold"
                              style={{
                                // fontSize: "24px",
                                marginTop: "auto",
                                // color: "rgb(74, 119, 74)",
                                color: "white",
                              }}
                            >
                              {/* 2 */}
                              لاگین
                            </p>
                          ) : modalStar > 1 ? (
                            <>
                              لاگین
                              <FaCheck
                                className=""
                                // style={{ color: "rgb(194, 221, 194) " }}
                                style={{ color: "rgb(246 102 86)" }}
                              />
                            </>
                          ) : (
                            // 2
                            "لاگین"
                          )}
                        </span>
                      </div>{" "}
                      {/* <span className="line"></span> */}
                      <div
                        className={`steps position-relative  ${
                          modalStar == 2
                            ? "process"
                            : modalStar > 2
                            ? "pass"
                            : ""
                        }`}
                      >
                        {/* {" "}
                      <span
                        className="position-absolute font-class"
                        style={{ top: "-25px", width: "100px" }}
                      >
                        انتخاب آدرس
                      </span>{" "} */}
                        <span
                          className="font-weight-bold  mx-auto"
                          style={{ marginRight: "-12px" }}
                        >
                          {modalStar == 2 ? (
                            <p
                              className=" font-weight-bold"
                              style={{
                                // fontSize: "24px",
                                marginTop: "auto",
                                // color: "rgb(74, 119, 74)",
                                color: "white",
                              }}
                            >
                              {/* 3 */}
                              آدرس
                            </p>
                          ) : modalStar > 2 ? (
                            <>
                              آدرس
                              <FaCheck
                                className=""
                                // style={{ color: "rgb(194, 221, 194) " }}
                                style={{ color: "rgb(246 102 86)" }}
                              />
                            </>
                          ) : (
                            // 3
                            " آدرس"
                          )}
                        </span>
                      </div>{" "}
                      {/* <span className="line"></span> */}
                      <div
                        className={`steps position-relative  ${
                          modalStar == 3
                            ? "process"
                            : modalStar > 3
                            ? "pass"
                            : ""
                        }`}
                      >
                        {/* {" "}
                      <span
                        className="position-absolute font-class"
                        style={{ top: "-25px", width: "100px" }}
                      >
                        پرداخت
                      </span>{" "} */}
                        <span
                          className="font-weight-bold  mx-auto"
                          style={{ marginRight: "-12px" }}
                        >
                          {modalStar == 3 ? (
                            <p
                              className="font-weight-bold"
                              style={{
                                // fontSize: "24px",
                                marginTop: "auto",
                                // color: "rgb(74, 119, 74)",
                                color: "white",
                              }}
                            >
                              {/* 4 */}
                              پرداخت
                            </p>
                          ) : modalStar > 3 ? (
                            <>
                              پرداخت
                              <FaCheck
                                className=""
                                // style={{ color: "rgb(194, 221, 194) " }}
                                style={{ color: "rgb(246 102 86)" }}
                              />
                            </>
                          ) : (
                            // 4
                            "پرداخت"
                          )}
                        </span>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {modalStar == 0 ? (
              <LogInNumber
                item={item}
                setItems={setItems}
                SetNumberStar={SetNumberStar}
                numberStar={numberStar}
                loginStar={LoginKeyStar}
                ChangeModalStar={changemodalStar}
                shoppingData={shoppingData}
                updateShoppingList={updateShoppingList}
                prices={prices}
                setPrices={setPrices}
                setIsLoading={setIsLoading}
              />
            ) : modalStar == 1 ? (
              <LogInCodeSabad
                ChangeModalStar={changemodalStar}
                loginkeyStar={loginkeyStar}
                SetNumberStar={SetNumberStar}
                numberStar={numberStar}
                item={item}
                setItems={setItems}
              />
            ) : modalStar == 2 ? (
              <MyAddress
                ChangeModalStar={changemodalStar}
                item={item}
                setItems={setItems}
                user_id={auth.userInfo.id}
                addressId={addressId}
                handleAddress={handleAddress}
              />
            ) : (
              <MyPay
                ChangeModalStar={changemodalStar}
                item={item}
                setItems={setItems}
                prices={prices}
                user_id={auth.userInfo.id}
                currentInventory={currentInventory}
                addressId={addressId}
                shoppingDataBusiness={shoppingDataBusiness}
                setShow={setShow}
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default SabadKharid;
